import { graphql } from '@api/generated/gql';

const setUserStatusMutation = graphql(`
  mutation setUserStatus($userId: ID!, $status: UserSetAvailabilityStatus!) {
    setUserStatus(userId: $userId, status: $status)
  }
`);

export default setUserStatusMutation;
